exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".support[data-v-9616dd12]{color:#000}.support .v--modal-box[data-v-9616dd12]{height:auto}.pd[data-v-9616dd12]{display:block;margin-left:20px}.pd[data-v-9616dd12]:first-letter{text-transform:uppercase}.share[data-v-9616dd12]{opacity:.5;pointer-events:none}.navbar-button[data-v-9616dd12]{background-color:#fff!important;color:#4baf4d;margin:15px}.navbar-button[data-v-9616dd12]:hover{opacity:.9}.navbar-button-icon[data-v-9616dd12]{background-color:#4baf4d!important;margin-bottom:-6px}.navbar-button-text[data-v-9616dd12]{padding-left:5px;color:#4baf4d!important;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-9616dd12&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/layouts/Dashboard.vue
// module id = 925
// module chunks = 2